import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox } from "vue";
import _imports_0 from '../../assets/images/JoinTriage_title.png';
import _imports_1 from '../../assets/images/JoinTriage_icon2.png';
const _hoisted_1 = { "data-cy": "login-page" };
const _hoisted_2 = { class: "row justify-content-center align-items center" };
const _hoisted_3 = { class: "col align-self-center" };
const _hoisted_4 = { class: "login-container" };
const _hoisted_5 = { class: "form-signin-heading" };
const _hoisted_6 = {
    class: "sr-only",
    for: "inputEmail"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
    class: "sr-only",
    for: "inputPassword"
};
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "form-text text-muted red" };
const _hoisted_13 = {
    key: 1,
    class: "form-text text-muted red",
    id: "emailHelp"
};
const _hoisted_14 = { class: "row align-items-center" };
const _hoisted_15 = {
    class: "col-auto px-2 cursor-pointer",
    for: "loginCheck"
};
const _hoisted_16 = { class: "text-center" };
const _hoisted_17 = {
    key: 0,
    class: "btn btn-lg btn-primary",
    "data-cy": "login-button",
    type: "submit"
};
const _hoisted_18 = { class: "version" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["RegisterAccountDialog"], { ref: "registerAccountDialog" }, null, 512),
        _createVNode($setup["ResendConfirmation"], { ref: "resendConfirmationDialog" }, null, 512),
        _createVNode($setup["BContainer"], { class: "d-flex h-100" }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-3" }, null, -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('JTADM_LOGIN')), 1),
                            _createElementVNode("form", {
                                class: "form-signin",
                                autocomplete: "on",
                                onSubmit: _withModifiers($setup.postLogin, ["prevent"])
                            }, [
                                _cache[5] || (_cache[5] = _createElementVNode("img", {
                                    class: "pt-2",
                                    src: _imports_0
                                }, null, -1)),
                                _cache[6] || (_cache[6] = _createElementVNode("img", {
                                    class: "pb-3",
                                    src: _imports_1
                                }, null, -1)),
                                _createElementVNode("label", _hoisted_6, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('JTADM_LAYOUT_EMAIL_ADDRESS')), 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    id: "inputEmail",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.userForm.email) = $event)),
                                    autocomplete: "username",
                                    "data-cy": "login-username-input",
                                    name: "username",
                                    type: "email",
                                    placeholder: _ctx.$t('JTADM_LAYOUT_EMAIL_ADDRESS')
                                }, null, 8, _hoisted_7), [
                                    [_vModelText, $setup.userForm.email]
                                ]),
                                _createElementVNode("label", _hoisted_8, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('JTADM_PASSWORD')), 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    id: "inputPassword",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.userForm.password) = $event)),
                                    autocomplete: "current-password",
                                    "data-cy": "login-password-input",
                                    name: "password",
                                    type: "password",
                                    placeholder: _ctx.$t('JTADM_PASSWORD')
                                }, null, 8, _hoisted_9), [
                                    [_vModelText, $setup.userForm.password]
                                ]),
                                ($setup.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createVNode($setup["Loading"])
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "checkbox" }, null, -1)),
                                _createVNode(_Transition, { name: "slide-fade" }, {
                                    default: _withCtx(() => [
                                        ($setup.confirmAction.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("p", _hoisted_12, _toDisplayString($setup.confirmAction[0]), 1),
                                                ($setup.confirmAction.length > 0)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "btn btn-sm btn-link btn-block",
                                                        type: "button",
                                                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                                                        //@ts-ignore
                                                        (...args) => ($setup.resendConfirmationDialog?.show && $setup.resendConfirmationDialog?.show(...args)), ["prevent"]))
                                                    }, _toDisplayString(_ctx.$t('JTADM_USERS_TROUBLESHOOT')), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : ($setup.something_wrong)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('JTADM_VALIDATION_WRONG_USER_PASS')), 1))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createElementVNode("div", _hoisted_14, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "col-auto ms-3 cursor-pointer",
                                        id: "loginCheck",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.userForm.remember) = $event)),
                                        "data-cy": "login-remember-me-checkbox",
                                        type: "checkbox"
                                    }, null, 512), [
                                        [_vModelCheckbox, $setup.userForm.remember]
                                    ]),
                                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('JTADM_LAYOUT_REMEMBER_ME')), 1)
                                ]),
                                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_16, [
                                    (!$setup.show_reset_password)
                                        ? (_openBlock(), _createElementBlock("button", _hoisted_17, _toDisplayString(_ctx.$t('JTADM_LAYOUT_SIGN_IN')), 1))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "btn btn-lg btn-danger",
                                            onClick: _withModifiers($setup.resetPassword, ["prevent"])
                                        }, _toDisplayString(_ctx.$t('JTADM_RESET_PASSWORD')), 1))
                                ]),
                                _createElementVNode("button", {
                                    class: "btn btn-lg btn-link btn-block",
                                    "data-cy": "register-account-button",
                                    type: "button",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(
                                    //@ts-ignore
                                    (...args) => ($setup.registerAccountDialog?.show && $setup.registerAccountDialog?.show(...args)), ["prevent"]))
                                }, "+ " + _toDisplayString(_ctx.$t('JTADM_USERS_REGISTER')), 1),
                                _createElementVNode("div", _hoisted_18, _toDisplayString($setup.version), 1)
                            ], 32)
                        ])
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-3" }, null, -1))
                ])
            ]),
            _: 1
        })
    ]));
}
